// @ts-nocheck
import { useEffect, useState, useRef, FC, FormEvent, ChangeEvent } from "react";
import styled from "styled-components";
import { apiCreatePpvGeneraleV2, apiEditPpvGeneraleV2 } from "../../../api/ppvApi";
import colors from "../../../styles/colors";

interface FormGroupProps {
    mb?: string;
}

const Container = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
`;

const ModalDialog = styled.div`
    position: relative;
    width: 100%;
    max-width: 600px;
    margin: 28px auto;
    pointer-events: none;
`;

const ModalContent = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    pointer-events: auto;
    background-color: ${colors.bgColorBlack2};
    color: white;
    background-clip: padding-box;
    border: 5px solid gold;
    border-radius: 5px;
    outline: 0;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
`;

const ModalHeader = styled.div`
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    padding: 16px;
    border-bottom: 1px solid #dee2e6;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    gap: 12px;
`;

const ModalHeaderTop = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;

const ModalDescription = styled.p`
    margin: 0;
    font-size: 16px;
    line-height: 1.5;
    letter-spacing: 1.5px;
    color: rgba(255, 255, 255, 0.8);
`;

const ModalTitle = styled.h5`
    margin: 0;
    line-height: 1.5;
    font-size: 20px;
    font-weight: 500;
    /* color: #000000; */
`;

const CloseButton = styled.button`
    box-sizing: content-box;
    width: 1em;
    height: 1em;
    padding: 4px;
    color: white;
    border: 0;
    border-radius: 4px;
    opacity: 0.5;
    background: transparent;
    cursor: pointer;
    font-size: 24px;
    font-weight: 700;
    line-height: 1;
    text-shadow: 0 1px 0 #fff;

    &:hover {
        opacity: 0.75;
    }

    &:before {
        content: "×";
    }
`;

const ModalBody = styled.div`
    position: relative;
    flex: 1 1 auto;
    padding: 16px;
    /* color: #000000; */
`;

const ModalFooter = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-shrink: 0;
    align-items: center;
    justify-content: flex-end;
    padding: 12px;
    border-top: 1px solid #dee2e6;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
    gap: 8px;
`;

const FormGroup = styled.div<FormGroupProps>`
    margin-bottom: ${props => props.mb || '16px'};
`;

const FormLabel = styled.label`
    display: inline-block;
    margin-bottom: 8px;
    font-weight: 500;
    /* color: #000000; */
`;

const FormInput = styled.input`
    display: block;
    width: 100%;
    padding: 6px 12px;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    /* color: #000000; */
    background-color: #ffffff;
    background-image: none;
    border: 1px solid #d3d3d3;
    border-radius: 4px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

    &:focus {
        /* color: #000000; */
        background-color: #ffffff;
        border-color: #86b7fe;
        outline: 0;
        box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.25);
    }

    &:disabled {
        background-color: #e9ecef;
        opacity: 1;
    }
`;

const FormTextarea = styled.textarea`
    display: block;
    width: 100%;
    padding: 6px 12px;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    /* color: #000000; */
    background-color: #ffffff;
    background-image: none;
    border: 1px solid #d3d3d3;
    border-radius: 4px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    resize: vertical;
    min-height: 100px;

    &:focus {
        /* color: #000000; */
        background-color: #ffffff;
        border-color: #86b7fe;
        outline: 0;
        box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.25);
    }

    &:disabled {
        background-color: #e9ecef;
        opacity: 1;
    }
`;

const RadioGroup = styled.div`
    display: flex;
    gap: 16px;
    margin-top: 8px;
`;

const RadioLabel = styled.label`
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-weight: 400;
    /* color: #000000; */

    input[type="radio"] {
        width: auto;
        margin: 0;
        cursor: pointer;
    }
`;

const Button = styled.button`
    display: inline-block;
    font-weight: 400;
    line-height: 1.5;
    /* color: #000000; */
    text-align: center;
    text-decoration: none;
    vertical-align: middle;
    cursor: pointer;
    user-select: none;
    background-color: transparent;
    border: 1px solid transparent;
    padding: 6px 12px;
    font-size: 16px;
    border-radius: 4px;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

    &:disabled {
        opacity: 0.65;
        cursor: not-allowed;
    }
`;

const ButtonPrimary = styled(Button)`
    color: white;
    background-color: #0d6efd;
    border-color: #0d6efd;

    &:hover:not(:disabled) {
        color: white;
        background-color: #0b5ed7;
        border-color: #0a58ca;
    }

    &:focus {
        color: #ffffff;
        background-color: #0b5ed7;
        border-color: #0a58ca;
        box-shadow: 0 0 0 4px rgba(49, 132, 253, 0.5);
    }
`;

const ButtonSecondary = styled(Button)`
    color: #ffffff;
    background-color: #6c757d;
    border-color: #6c757d;

    &:hover:not(:disabled) {
        color: #ffffff;
        background-color: #5c636a;
        border-color: #565e64;
    }

    &:focus {
        color: #ffffff;
        background-color: #5c636a;
        border-color: #565e64;
        box-shadow: 0 0 0 4px rgba(130, 138, 145, 0.5);
    }
`;

const ErrorText = styled.p`
    margin-top: 4px;
    margin-bottom: 0;
    color: #dc3545;
    font-size: 14px;
`;

const StatusMessage = styled.div`
    text-align: right;
    padding: 0 16px;
    margin-top: 8px;
    color: #000000;
`;

const SuccessText = styled.div`
    text-align: right;
    padding: 0 16px;
    margin-top: 8px;
    color: #198754;
`;

const FileInfoText = styled.p`
    margin-top: 8px;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.6);
    font-style: italic;
`;

const FileSelectedText = styled.p`
    margin-top: 8px;
    font-size: 14px;
    color: #198754;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 8px;

    &::before {
        content: "✓";
        color: #198754;
        font-weight: bold;
    }
`;

const FileSelectedContainer = styled.div`
    margin-top: 8px;
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
`;

const RemoveFileButton = styled.button`
    padding: 4px 12px;
    font-size: 12px;
    background-color: #dc3545;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 500;
    transition: background-color 0.2s ease-in-out;

    &:hover {
        background-color: #c82333;
    }

    &:active {
        transform: scale(0.98);
    }
`;

interface PpvGeneraleEditData {
    id?: number;
    name?: string;
    description?: string;
    is_big_four?: number | boolean;
    is_active?: number | boolean;
    img_path?: string;
}

interface ErrorsForm {
    name?: string | string[];
    description?: string | string[];
    poster?: string | string[];
    is_big_four?: string | string[];
    is_active?: string | string[];
    [key: string]: string | string[] | undefined;
}

interface ApiResponse {
    errors?: ErrorsForm;
    [key: string]: unknown;
}

interface Props {
    editData?: PpvGeneraleEditData | null;
    closeModalClick: () => void;
    onPpvCreated?: () => void;
}

const CreatePpvGeneraleModale: FC<Props> = (props: any) => {
    const { editData } = props;
    const isEditMode = !!editData;
    const formRef = useRef<HTMLFormElement>(null);

    const [responseApiCreatePpv, setResponseApiCreatePpv] = useState<ApiResponse>({});
    const [errorsForm, setErrorsForm] = useState<ErrorsForm>({});
    const [isLoadingForm, setIsLoadingForm] = useState<boolean>(false);
    const [ppvCreated, setPpvCreated] = useState<boolean>(false);
    const [isFirstRendering, setIsFirstRendering] = useState<boolean>(true);
    const [selectedFile, setSelectedFile] = useState<File | null>(null);

    const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
        setIsLoadingForm(true);
        setErrorsForm({});
        event.preventDefault();

        const formData = new FormData(event.currentTarget);
        const data = {
            name: formData.get('name') as string,
            description: formData.get('description') as string,
            is_big_four: (formData.get('is_big_four') as string) || '0',
            is_active: (formData.get('is_active') as string) || '0',
            poster: (event.currentTarget.poster as HTMLInputElement)?.files?.[0] || null
        };

        const formDataToSend = new FormData();
        formDataToSend.append('name', data.name);
        formDataToSend.append('description', data.description || '');
        formDataToSend.append('is_big_four', data.is_big_four);
        formDataToSend.append('is_active', data.is_active);
        if (data.poster) {
            formDataToSend.append('poster', data.poster);
        }

        try {
            let response: ApiResponse;
            if (isEditMode && editData?.id) {
                response = await apiEditPpvGeneraleV2(formDataToSend, editData.id) as unknown as ApiResponse;
            } else {
                response = await apiCreatePpvGeneraleV2(formDataToSend) as unknown as ApiResponse;
            }
            setResponseApiCreatePpv(response);
        } catch (error) {
            console.error('Errore durante la creazione/modifica del PPV:', error);
            setIsLoadingForm(false);
        }
    };

    useEffect(() => {
        if (!isFirstRendering) {
            if (responseApiCreatePpv.errors) {
                setErrorsForm(responseApiCreatePpv.errors);
                setIsLoadingForm(false);
            } else if (Object.keys(responseApiCreatePpv).length > 0) {
                setIsLoadingForm(false);
                setPpvCreated(true);
                if (props.onPpvCreated) {
                    props.onPpvCreated();
                }
            }
        } else {
            setIsFirstRendering(false);
        }
    }, [responseApiCreatePpv, props, isFirstRendering]);

    const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            setSelectedFile(file);
        } else {
            setSelectedFile(null);
        }
    };

    const handleRemoveFile = () => {
        setSelectedFile(null);
        if (formRef.current) {
            const fileInput = formRef.current.querySelector('input[type="file"]') as HTMLInputElement;
            if (fileInput) {
                fileInput.value = '';
            }
        }
    };


    const handleCloseModal = () => {
        if (ppvCreated && props.onPpvCreated) {
            props.onPpvCreated();
        }
        if (formRef.current) {
            formRef.current.reset();
        }
        setPpvCreated(false);
        setErrorsForm({});
        setSelectedFile(null);
        props.closeModalClick();
    };

    useEffect(() => {
        if (formRef.current) {
            const form = formRef.current;
            if (editData) {
                if (form.elements.namedItem('name')) {
                    (form.elements.namedItem('name') as HTMLInputElement).value = editData.name || '';
                }
                if (form.elements.namedItem('description')) {
                    (form.elements.namedItem('description') as HTMLTextAreaElement).value = editData.description || '';
                }

                const bigFourRadios = form.querySelectorAll('input[name="is_big_four"]');
                bigFourRadios.forEach(radio => {
                    const radioInput = radio as HTMLInputElement;
                    radioInput.checked = (radioInput.value === (editData.is_big_four ? '1' : '0'));
                });

                const activeRadios = form.querySelectorAll('input[name="is_active"]');
                activeRadios.forEach(radio => {
                    const radioInput = radio as HTMLInputElement;
                    radioInput.checked = (radioInput.value === (editData.is_active ? '1' : '0'));
                });
            } else {
                form.reset();
            }
            setSelectedFile(null);
        }
    }, [editData]);

    return (
        <Container className="create-ppv-generale-modale-container">
            <ModalDialog className="create-ppv-generale-modale-dialog">
                <ModalContent className="create-ppv-generale-modale-content">
                    <form ref={formRef} onSubmit={handleSubmit} encType="multipart/form-data" className="create-ppv-generale-modale-form">
                        <ModalHeader className="create-ppv-generale-modale-header">
                            <ModalHeaderTop className="create-ppv-generale-modale-header-top">
                                <ModalTitle className="create-ppv-generale-modale-title">
                                    {isEditMode ? 'Modifica PPV Generale' : 'Crea Nuovo PPV Generale'}
                                </ModalTitle>
                                <CloseButton type="button" aria-label="Close" onClick={handleCloseModal} className="create-ppv-generale-modale-close-button"></CloseButton>
                            </ModalHeaderTop>
                            <ModalDescription className="create-ppv-generale-modale-title-description">Ricorda. Questo è il PPV Generale, non il PPV specifico. Esempio: Forumania-Global Rumble-Survivor Series... per creare il PPV specifico, devi cliccare su Forumania o Rumble o Series e da lì inserisci la data e le info del ppv</ModalDescription>
                        </ModalHeader>
                        <ModalBody className="create-ppv-generale-modale-body">
                            <FormGroup className="create-ppv-generale-modale-form-group">
                                <FormLabel htmlFor="name" className="create-ppv-generale-modale-label">Nome PPV *</FormLabel>
                                <FormInput
                                    type="text"
                                    id="name"
                                    name="name"
                                    required
                                    className="create-ppv-generale-modale-input"
                                    defaultValue={editData?.name || ''}
                                />
                                {errorsForm.name && <ErrorText className="create-ppv-generale-modale-error-text">{Array.isArray(errorsForm.name) ? errorsForm.name[0] : errorsForm.name}</ErrorText>}
                            </FormGroup>

                            <FormGroup className="create-ppv-generale-modale-form-group">
                                <FormLabel htmlFor="description" className="create-ppv-generale-modale-label">Descrizione</FormLabel>
                                <FormTextarea
                                    id="description"
                                    name="description"
                                    rows={4}
                                    className="create-ppv-generale-modale-textarea"
                                    defaultValue={editData?.description || ''}
                                />
                                {errorsForm.description && <ErrorText className="create-ppv-generale-modale-error-text">{Array.isArray(errorsForm.description) ? errorsForm.description[0] : errorsForm.description}</ErrorText>}
                            </FormGroup>

                            <FormGroup className="create-ppv-generale-modale-form-group">
                                <FormLabel htmlFor="poster" className="create-ppv-generale-modale-label">
                                    Poster Generico
                                    {isEditMode && (
                                        <FileInfoText className="create-ppv-generale-modale-file-info-text" style={{ marginTop: '4px', marginBottom: '0' }}>
                                            (Se non vuoi modificare il poster, non cliccare nulla)
                                        </FileInfoText>
                                    )}
                                </FormLabel>
                                <FormInput
                                    type="file"
                                    id="poster"
                                    name="poster"
                                    accept="image/*"
                                    className="create-ppv-generale-modale-input"
                                    onChange={handleFileChange}
                                />
                                {editData?.img_path && !selectedFile && (
                                    <FileInfoText className="create-ppv-generale-modale-file-info-text">
                                        Poster attuale: {editData.img_path}
                                    </FileInfoText>
                                )}
                                {selectedFile && (
                                    <FileSelectedContainer className="create-ppv-generale-modale-file-selected-container">
                                        <FileSelectedText className="create-ppv-generale-modale-file-selected-text">
                                            File selezionato: {selectedFile.name}
                                        </FileSelectedText>
                                        <RemoveFileButton
                                            type="button"
                                            onClick={handleRemoveFile}
                                            className="create-ppv-generale-modale-remove-file-button"
                                        >
                                            Rimuovi
                                        </RemoveFileButton>
                                    </FileSelectedContainer>
                                )}
                                {errorsForm.poster && <ErrorText className="create-ppv-generale-modale-error-text">{Array.isArray(errorsForm.poster) ? errorsForm.poster[0] : errorsForm.poster}</ErrorText>}
                            </FormGroup>

                            <FormGroup className="create-ppv-generale-modale-form-group">
                                <FormLabel className="create-ppv-generale-modale-label">È Big PPV?</FormLabel>
                                <RadioGroup className="create-ppv-generale-modale-radio-group">
                                    <RadioLabel className="create-ppv-generale-modale-radio-label">
                                        <input
                                            type="radio"
                                            name="is_big_four"
                                            value="1"
                                            defaultChecked={editData ? editData.is_big_four === 1 : false}
                                        />
                                        Si
                                    </RadioLabel>
                                    <RadioLabel className="create-ppv-generale-modale-radio-label">
                                        <input
                                            type="radio"
                                            name="is_big_four"
                                            value="0"
                                            defaultChecked={editData ? editData.is_big_four === 0 : true}
                                        />
                                        No
                                    </RadioLabel>
                                </RadioGroup>
                                {errorsForm.is_big_four && <ErrorText className="create-ppv-generale-modale-error-text">{Array.isArray(errorsForm.is_big_four) ? errorsForm.is_big_four[0] : errorsForm.is_big_four}</ErrorText>}
                            </FormGroup>

                            <FormGroup className="create-ppv-generale-modale-form-group">
                                <FormLabel className="create-ppv-generale-modale-label">È attivo?</FormLabel>
                                <RadioGroup className="create-ppv-generale-modale-radio-group">
                                    <RadioLabel className="create-ppv-generale-modale-radio-label">
                                        <input
                                            type="radio"
                                            name="is_active"
                                            value="1"
                                            defaultChecked={editData ? editData.is_active === 1 : true}
                                        />
                                        Si
                                    </RadioLabel>
                                    <RadioLabel className="create-ppv-generale-modale-radio-label">
                                        <input
                                            type="radio"
                                            name="is_active"
                                            value="0"
                                            defaultChecked={editData ? editData.is_active === 0 : false}
                                        />
                                        No
                                    </RadioLabel>
                                </RadioGroup>
                                {errorsForm.is_active && <ErrorText className="create-ppv-generale-modale-error-text">{Array.isArray(errorsForm.is_active) ? errorsForm.is_active[0] : errorsForm.is_active}</ErrorText>}
                            </FormGroup>
                        </ModalBody>
                        <ModalFooter className="create-ppv-generale-modale-footer">
                            <ButtonSecondary type="button" onClick={handleCloseModal} className="create-ppv-generale-modale-button-secondary">Chiudi</ButtonSecondary>
                            <ButtonPrimary type="submit" disabled={isLoadingForm || ppvCreated} className="create-ppv-generale-modale-button-primary">
                                {isLoadingForm ? 'Caricamento...' : (isEditMode ? 'Modifica PPV' : 'Crea PPV')}
                            </ButtonPrimary>
                        </ModalFooter>
                        {isLoadingForm && <StatusMessage className="create-ppv-generale-modale-status-message">Caricamento..</StatusMessage>}
                        {ppvCreated && <SuccessText className="create-ppv-generale-modale-success-text">
                            {isEditMode ? 'PPV modificato con successo!' : 'PPV creato con successo!'}
                        </SuccessText>}
                    </form>
                </ModalContent>
            </ModalDialog>
        </Container>
    );
};

export default CreatePpvGeneraleModale;
